module.exports = __webpack_public_path__ + "img/sand-rock-big-14.9da6648e.png";